/**
 * Menu Categories Configuration
 * Groups all teacher menu items into 6 main categories for cleaner sidebar navigation
 */

import {
    LayoutDashboard, BarChart3, ClipboardList, Eye,
    FileEdit, Archive, Target, Brain, HelpCircle,
    BookOpen, CalendarDays, Presentation, FileText, GraduationCap, Lightbulb, PenSquare, Drama,
    ClipboardCheck, FileSpreadsheet, Settings, BarChart2, UserCheck,
    Users, Library, BookMarked,
    Sparkles, MessageSquare, Image, Paintbrush, Wand2, Code,
    Map, ListTree, Database
} from 'lucide-react';

export const menuCategories = [
    {
        id: 'dashboard',
        label: 'Dashboard & Monitoring',
        icon: LayoutDashboard,
        color: 'from-blue-500 to-cyan-500',
        bgColor: 'bg-blue-50',
        textColor: 'text-blue-600',
        description: 'Lihat ringkasan data dan monitoring aktivitas',
        items: [
            { id: 'dashboard_main', label: 'Dashboard Utama', targetPage: 'dashboard', icon: LayoutDashboard, description: 'Halaman utama berisi ringkasan fitur' },
            { id: 'dashboard_terpadu', label: 'Dashboard Terpadu', targetPage: 'guru_dashboard_terintegrasi', icon: BarChart3, description: 'Overview data terintegrasi' },
            { id: 'monitoring_ujian', label: 'Monitoring Ujian', targetPage: 'exam_grading', icon: Eye, description: 'Pantau hasil ujian siswa' },
            { id: 'penilaian_komprehensif', label: 'Penilaian Komprehensif', targetPage: 'assessment-comprehensive', icon: ClipboardList, description: 'Dashboard gabungan penilaian' },
        ]
    },
    {
        id: 'perencanaan',
        label: 'Perencanaan',
        icon: CalendarDays,
        color: 'from-sky-500 to-blue-600',
        bgColor: 'bg-sky-50',
        textColor: 'text-sky-600',
        description: 'Perencanaan pembelajaran (CP, TP, ATP, Asesmen)',
        items: [
            { id: 'bank_cp', label: 'Bank CP', targetPage: 'bank-cp', icon: Library, description: 'Bank Capaian Pembelajaran' },
            { id: 'bank_tp', label: 'Bank TP', targetPage: 'bank-tp', icon: Target, description: 'Bank Tujuan Pembelajaran' },
            { id: 'kelola_atp', label: 'Kelola ATP', targetPage: 'kelola-atp', icon: Map, description: 'Alur Tujuan Pembelajaran' },
            { id: 'rencana_asesmen', label: 'Rencana Asesmen', targetPage: 'rencana-asesmen', icon: ClipboardCheck, description: 'Perencanaan Asesmen' },
            { id: 'kelola_jenis_penilaian', label: 'Kelola Jenis Penilaian', targetPage: 'assessment-types', icon: Settings, description: 'Kelola jenis penilaian (Sumatif, Formatif, dll)' },
        ]
    },
    {
        id: 'soal',
        label: 'Buat Soal & Asesmen',
        icon: FileEdit,
        color: 'from-emerald-500 to-green-500',
        bgColor: 'bg-emerald-50',
        textColor: 'text-emerald-600',
        description: 'Buat dan kelola soal, quiz, dan asesmen',
        items: [
            { id: 'buat_soal', label: 'Buat Soal', targetPage: 'soal', icon: FileEdit, description: 'Buat soal dengan bantuan AI', isPremium: true },
            { id: 'kelola_soal', label: 'Kelola Soal Ulangan', targetPage: 'guru_soal', icon: FileText, description: 'Kelola dan kirim soal ulangan' },
            { id: 'bank_soal', label: 'Bank Soal', targetPage: 'bank_soal', icon: Archive, description: 'Simpan dan kelola draf soal' },
            { id: 'soal_diagnostik', label: 'Soal Diagnostik', targetPage: 'diagnostic-quiz', icon: Brain, description: 'Buat asesmen diagnostik interaktif' },
            { id: 'kelola_quiz', label: 'Kelola Quiz Interaktif', targetPage: 'guru_quiz', icon: Target, description: 'Kelola dan kirim quiz interaktif' },
            { id: 'soal_quiz_interaktif', label: 'Soal Quiz Interaktif', targetPage: 'create-quiz', icon: HelpCircle, description: 'Buat soal untuk Kahoot, Quizizz, dll' },
        ]
    },
    {
        id: 'konten',
        label: 'Buat Konten & Materi',
        icon: BookOpen,
        color: 'from-purple-500 to-violet-500',
        bgColor: 'bg-purple-50',
        textColor: 'text-purple-600',
        description: 'Buat materi, modul, dan konten pembelajaran',
        items: [
            { id: 'prota_prosem', label: 'Prota & Prosem', targetPage: 'prota', icon: CalendarDays, description: 'Buat Program Tahunan & Semester', isPremium: true },
            { id: 'buat_materi', label: 'Buat Materi Ajar', targetPage: 'materi', icon: BookOpen, description: 'Buat materi pembelajaran', isPremium: true },
            { id: 'buat_modul', label: 'Buat Modul Ajar', targetPage: 'modul-ajar', icon: GraduationCap, description: 'Buat modul ajar dengan AI' },
            { id: 'rangkuman', label: 'Rangkuman Materi', targetPage: 'rangkuman', icon: FileText, description: 'Buat rangkuman materi', isPremium: true },
            { id: 'presentasi', label: 'Kerangka Presentasi', targetPage: 'presentasi', icon: Presentation, description: 'Buat kerangka presentasi', isPremium: true },
            { id: 'buat_lkpd', label: 'Buat LKPD', targetPage: 'lkpd', icon: FileText, description: 'Buat lembar kerja peserta didik', isPremium: true },
            { id: 'kelola_lkpd', label: 'Kelola LKPD', targetPage: 'guru_lkpd', icon: ClipboardList, description: 'Kelola dan kirim LKPD' },
            { id: 'buat_cerita', label: 'Buat Cerita/Kasus', targetPage: 'cerita', icon: PenSquare, description: 'Buat cerita untuk pembelajaran', isPremium: true },
            { id: 'skenario', label: 'Skenario Belajar', targetPage: 'skenario', icon: Drama, description: 'Buat skenario pembelajaran', isPremium: true },
            { id: 'buat_rubrik', label: 'Pembuat Rubrik', targetPage: 'rubrik', icon: ClipboardCheck, description: 'Buat rubrik penilaian', isPremium: true },
            { id: 'game_html', label: 'Game Edukasi HTML', targetPage: 'game-builder', icon: Code, description: 'Buat game dengan kode HTML dari Canva', isPremium: true },
        ]
    },
    {
        id: 'penilaian',
        label: 'Penilaian & Rapor',
        icon: ClipboardCheck,
        color: 'from-amber-500 to-orange-500',
        bgColor: 'bg-amber-50',
        textColor: 'text-amber-600',
        description: 'Input nilai, kelola rapor, dan analisis capaian',
        items: [
            { id: 'grading_analisis', label: 'Dashboard Monitoring Ujian', targetPage: 'exam_grading', icon: ClipboardCheck, description: 'Kelola dan review hasil ujian secara real-time' },
            { id: 'input_nilai', label: 'Input Nilai', targetPage: 'integrated-score', icon: Target, description: 'Input nilai siswa terintegrasi' },
            { id: 'pusat_rapor', label: 'Pusat Rapor', targetPage: 'rapor-center', icon: FileSpreadsheet, description: 'Kelola nilai dan cetak rapor' },
            { id: 'analisis_tp', label: 'Rekapan Nilai & Analisis TP', targetPage: 'tp-analysis', icon: Target, description: 'Rekapan nilai siswa dan analisis capaian Tujuan Pembelajaran' },
            { id: 'analisis_kelas', label: 'Analisis Kelas', targetPage: 'analisis', icon: BarChart2, description: 'Analisis performa kelas', isPremium: true },
            { id: 'deskripsi_siswa', label: 'Deskripsi Kualitatif Siswa', targetPage: 'qualitative-description', icon: UserCheck, description: 'Deskripsi perkembangan siswa' },
        ]
    },
    {
        id: 'kelas',
        label: 'Kelola Kelas & Siswa',
        icon: Users,
        color: 'from-pink-500 to-rose-500',
        bgColor: 'bg-pink-50',
        textColor: 'text-pink-600',
        description: 'Kelola rombel, konten, dan jurnal mengajar',
        items: [
            { id: 'kelola_rombel', label: 'Kelola Rombel', targetPage: 'rombel-management', icon: Users, description: 'Manajemen rombongan belajar' },
            { id: 'bank_konten', label: 'Bank Konten', targetPage: 'bankkonten', icon: Library, description: 'Simpan dan kelola konten pembelajaran' },
            { id: 'jurnal_mengajar', label: 'Jurnal Mengajar', targetPage: 'jurnal', icon: BookMarked, description: 'Catat aktivitas mengajar harian' },
        ]
    },
    {
        id: 'ai_tools',
        label: 'AI & Tools',
        icon: Sparkles,
        color: 'from-indigo-500 to-blue-600',
        bgColor: 'bg-indigo-50',
        textColor: 'text-indigo-600',
        description: 'Chat AI, script generator, dan tools kreatif',
        items: [
            { id: 'chat_ai', label: 'Chat dengan AI', targetPage: 'chat', icon: MessageSquare, description: 'Chat dan tanya jawab dengan AI', isPremium: true },
            { id: 'script_generator', label: 'Script Generator', targetPage: 'script-generator', icon: Sparkles, description: 'Generator prompt untuk AI' },
            { id: 'ide_kreatif', label: 'Generator Ide Kreatif', targetPage: 'edutainment-generator', icon: Lightbulb, description: 'Temukan ide mengajar kreatif' },
            { id: 'ide_aktivitas', label: 'Ide Aktivitas', targetPage: 'ide', icon: Lightbulb, description: 'Ide aktivitas pembelajaran', isPremium: true },
            { id: 'ide_media', label: 'Ide Media Canva', targetPage: 'media', icon: Paintbrush, description: 'Ide desain media pembelajaran', isPremium: true },

        ]
    }
];

// Utility functions
export const getAllMenuItems = () => {
    return menuCategories.flatMap(cat => cat.items.map(item => ({
        ...item,
        categoryId: cat.id,
        categoryLabel: cat.label
    })));
};

export const searchMenuItems = (query) => {
    if (!query || query.trim() === '') return getAllMenuItems();

    const lowerQuery = query.toLowerCase();
    return getAllMenuItems().filter(item =>
        item.label.toLowerCase().includes(lowerQuery) ||
        item.description.toLowerCase().includes(lowerQuery) ||
        item.categoryLabel.toLowerCase().includes(lowerQuery)
    );
};

export const getCategoryById = (categoryId) => {
    return menuCategories.find(cat => cat.id === categoryId);
};

export default menuCategories;
